import React from "react";
import styles from "./styles/transparent-btn.css";
import PropTypes from "prop-types";
import IconSpinner from "../icon-spinner";

const TransparentButton = (props) => {
    const {
        text = "",
        leftImage = null,
        id = "",
        disabled = false,
        customStyle = [],
        onClick = null,
        isLoading = false
    } = props;
    let buttonStyles = [];
    customStyle.forEach((item) => {
        buttonStyles.push(`styles.${item}`);
    });
    buttonStyles = buttonStyles.join(" ");
    const disabledStyle = disabled ? "styles.disable-btn" : "";
    return (
        <button
            id={id}
            disabled={disabled || isLoading}
            onClick={onClick}
            type="button"
            className={"btn"}
            styleName={`styles.transparent-btn styles.btn-style ${disabledStyle} ${buttonStyles ? buttonStyles : ""}`}
        >
            <span>
                {leftImage && <img styleName={"styles.img-left"} src={leftImage} />}
                {text}
                {isLoading ? <IconSpinner /> : null}
            </span>
        </button>
    );
};

TransparentButton.propTypes = {
    leftImage: PropTypes.any,
    text: PropTypes.string,
    id: PropTypes.string,
    disabled: PropTypes.bool,
    customStyle: PropTypes.array,
    onClick: PropTypes.func,
    isLoading: PropTypes.bool
};

export default TransparentButton;
